import React, { useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import './AnimatedBackground.css';

function AnimatedBackground() {
  const canvasRef = useRef(null);
  const { isDark } = useTheme();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    // Floating orbs system
    const orbs = [];
    const orbCount = 25;

    class Orb {
      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 100 + 50;
        this.speedX = (Math.random() - 0.5) * 0.3;
        this.speedY = (Math.random() - 0.5) * 0.3;
        this.isBlue = Math.random() > 0.5;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;

        if (this.x > canvas.width + this.size) this.x = -this.size;
        if (this.x < -this.size) this.x = canvas.width + this.size;
        if (this.y > canvas.height + this.size) this.y = -this.size;
        if (this.y < -this.size) this.y = canvas.height + this.size;
      }

      draw() {
        const gradient = ctx.createRadialGradient(
          this.x, this.y, 0,
          this.x, this.y, this.size
        );

        if (this.isBlue) {
          if (isDark) {
            gradient.addColorStop(0, 'rgba(43, 127, 255, 0.15)');
            gradient.addColorStop(1, 'rgba(43, 127, 255, 0)');
          } else {
            gradient.addColorStop(0, 'rgba(30, 95, 204, 0.08)');
            gradient.addColorStop(1, 'rgba(30, 95, 204, 0)');
          }
        } else {
          if (isDark) {
            gradient.addColorStop(0, 'rgba(255, 140, 66, 0.12)');
            gradient.addColorStop(1, 'rgba(255, 140, 66, 0)');
          } else {
            gradient.addColorStop(0, 'rgba(255, 107, 26, 0.06)');
            gradient.addColorStop(1, 'rgba(255, 107, 26, 0)');
          }
        }

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Create orbs
    for (let i = 0; i < orbCount; i++) {
      orbs.push(new Orb());
    }

    // Animation loop
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      orbs.forEach(orb => {
        orb.update();
        orb.draw();
      });

      requestAnimationFrame(animate);
    }

    animate();

    // Resize handler
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isDark]);

  return <canvas ref={canvasRef} className="animated-background" />;
}

export default AnimatedBackground;
